module.exports = __webpack_public_path__ + "img/zjtq_banner_zt_img.28d60866.png";